const { CALL_INTAKE_V2_API } = require('middleware/intakeV2Api');
const {
  GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE
} = require('../types/temporaryLivingTypes');

export const getTemporaryLivingAssignments = id => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST, GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS, GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/tempAssignments`,
      method: 'GET'
    }
  };
};

export const postTemporaryLivingAssignments = (id, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST, POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS, POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE],
      authenticated: true,
      endpoint: `api/authorizations/${id}/tempAssignments`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateTemporaryLivingAssignments = (id, tempId, values) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
        UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
        UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${id}/tempAssignments/${tempId}`,
      method: 'PUT',
      payload: values
    }
  };
};

export const deleteTemporaryLivingAssignment = (id, tempId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [
        DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST,
        DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
        DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE
      ],
      authenticated: true,
      endpoint: `api/authorizations/${id}/tempAssignments/${tempId}`,
      method: 'DELETE'
    }
  };
};
